// extracted by mini-css-extract-plugin
export default {"container":"TQ-z","topReviewHeading":"UQ-z","criticalReview":"VQ-z","favorableReview":"WQ-z","vsSeparator":"XQ-z"};